module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/2/4-b4dc2f8822a75e4d62c4d94d393a8c48.jpg";